"use strict";

export const formStyles = `
.grid {
    padding-left: 5px;
    padding-bottom: 2px;
}

.add_button,
.remove_button {
    margin-left: 22px;
}

.item-question__field-label {
    font-weight: bold;
}

.header {
    background-color: #57C5B6;
}

.footer {
    background-color: #57C5B6;
}

.callbackMessage,
.supportFloatingText,
.supportLink {
    border: 1px solid #159895;
    color: #159895;
    font-weight: normal;
}

.atchButton {
    color: #fff;
    background-color: #3B3B3B;
    border-color: #3B3B3B;
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);

    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    font-size: 0.875rem;
    border-radius: 0.25rem;

    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
}

.input-chkbox {
    margin-right: 5px;
}

.choice-select {
    border-radius: 8px;
}

.choice-select:not(:checked) {
    border-radius: 8px;
}

.date {
    border-radius: 8px;
    padding-left: 5px;
    padding-right: 5px;
}

.dateTime {
    border-radius: 8px;
    padding-left: 5px;
    padding-right: 5px;
}

.decimal {
    padding-left: 5px;
    border-radius: 8px;
}

.integer {
    border-radius: 8px;
}


.quantity {
    border-radius: 8px;
    padding-left: 5px;
}

.string {
    border-radius: 8px;
    padding-left: 5px;
}

.text {
    border-radius: 8px;
}

.time {
    border-radius: 8px;
    padding-left: 5px;
    padding-right: 5px;
}

.url {
    border-radius: 8px;
    padding-left: 5px;
}
`;
